<div class="row align-items-start mt-3">
  <!-- Main Module -->
  <div class="col-md-3">
    <div class="d-flex flex-column">
      <h5 class="mb-2">{{ module.name }}</h5>
      <select
        class="form-select"
        [(ngModel)]="module.isEnabled"
        (change)="toggleModule()"
      >
        <option [value]=true>Enabled</option>
        <option [value]=false>Disabled</option>
      </select>
    </div>
  </div>

  <!-- Dynamic Checkboxes -->
  <div class="col-md-9">
    <div class="d-flex flex-wrap align-items-center">
      <div
        *ngFor="let option of module.options"
        class="form-check me-4 d-flex align-items-center"
        style="width: auto;"
      >
        <input
          type="checkbox"
          class="form-check-input"
          [(ngModel)]="option.isChecked"
          id="{{ module.id }}-{{ option.name }}"
          style="margin-right: 6px;"
        />
        <label
          class="form-check-label"
          for="{{ module.id }}-{{ option.name }}"
          style="margin-bottom: 0;"
        >
          {{ option.name }}
        </label>
      </div>
    </div>
  </div>
</div>
